module.exports = __webpack_public_path__ + "static/media/DannySelfie.aa6d0b8c.jpg";